import React from 'react';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';

import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import RequestWithTimeoutProvider from '@app/components/LocalCommon/RequestWithTimeoutProvider/RequestWithTimeoutProvider';
import AttentionMessagesWrapper from '@app/components/UI/AttentionMessage/AttentionMessagesWrapper';
import CookieBanner from '@app/components/UI/CookieBanner/CookieBanner';
import { SentryErrorBoundary } from '@app/components/UI/ErrorBoundary/SentryErrorBoundary';
import PhoneProvider from '@app/components/UI/PhoneProvider/PhoneProvider';
import { ApplicationState } from '@app/store';

const LayoutWrapper = (props) => {
	const location = useLocation();

	const hiddenStyles: React.CSSProperties = {
		display: 'none',
		visibility: 'hidden',
	};

	React.useEffect(() => {
		if (!props.debug) {
			ReactGA.initialize('UA-26388509-1');
		}
	}, []);

	React.useEffect(() => {
		ReactGA.pageview(location.pathname + location.search);
	}, [location.pathname, location.search]);

	return (
		<SentryErrorBoundary>
			<RequestProvider>
				<RequestWithTimeoutProvider>
					<PhoneProvider phone="(855) 933-5683">
						<noscript>
							<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-53KG2QP" height="0" width="0" style={hiddenStyles} title="ns.html?id=GTM-53KG2QP" />
						</noscript>
						<Outlet />
						<CookieBanner />
						<AttentionMessagesWrapper />
					</PhoneProvider>
				</RequestWithTimeoutProvider>
			</RequestProvider>
		</SentryErrorBoundary>
	);
};
export default connect<any, any, any, ApplicationState>((state: ApplicationState) => state.login)(LayoutWrapper);
